<template>
    <div class="basic">
        <div class="manage-title"><em class="txt">好友信息</em></div>
        <div class="friendBox flex margin-top-20">
            <div class="item radius">
                <p class="txt ff9203">{{wechat_group_num.friendCount}}</p>
                <p class="tit">微信好友</p>
            </div>
            <div class="item radius">
              <p class="txt ff9203">{{wechat_group_num.wechatGroupCount}}</p>
              <p class="tit">微信群数</p>
            </div>
            <div class="item radius">
                <p class="txt ff9203">{{wechat_group_num.qinyou}}</p>
                <p class="tit">亲友群</p>
            </div>
            <div class="item radius">
                <p class="txt ff9203">{{wechat_group_num.friend}}</p>
                <p class="tit">好友群</p>
            </div>
            <div class="item radius">
                <p class="txt ff9203">{{wechat_group_num.classmate}}</p>
                <p class="tit">同学群</p>
            </div>
            <div class="item radius">
                <p class="txt ff9203">{{wechat_group_num.hobby}}</p>
                <p class="tit">兴趣爱好群</p>
            </div>
            <div class="item radius">
                <p class="txt ff9203">{{wechat_group_num.industry}}</p>
                <p class="tit">行业交流群</p>
            </div>
            <div class="item radius">
                <p class="txt ff9203">{{wechat_group_num.other}}</p>
                <p class="tit">其他</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
   name: 'InfoFriend',
   props: {
       wechat_group: String,
       wechat_friend_num: String,
       wechat_group_num: Object
   }
}
</script>
<style scoped>
    .friendBox{flex-wrap: wrap;}
    .friendBox .item{text-align: center;padding:12px 0;width:100px;border:1px #f1f1f1 solid;margin-right: 15px;margin-bottom:15px;}
    .friendBox p{line-height:30px;}
    .friendBox .txt{font-size:24px;}
</style>
